import React from "react";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

export default function SavedLogbookItemsDrawer({
  open,
  onClose,
  categories,
  agents,
  onRestoreCategory,
  onDeleteCategory,
  onRestoreAgent,
  onEditAgent,
}) {
  const actionClass =
    "rounded-lg p-2 text-slate-500 hover:bg-violet-50 hover:text-violet-700 focus-visible:ring-2 focus-visible:ring-violet-500";
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div className="w-[450px] max-w-[100vw] h-full overflow-auto bg-slate-50 px-6 py-6">
        <div className="flex items-center justify-between gap-3">
          <h2 className="text-2xl text-slate-900">Saved items</h2>
          <button
            className={actionClass}
            aria-label="Close saved items"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <p className="mt-3 text-sm text-slate-500">
          Previously saved categories and agents that aren’t on this layout.
          Choose one to add here, then save the layout.
        </p>
        {categories.length > 0 && (
          <section className="mt-6">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">
              Categories
            </h3>
            <div className="space-y-2">
              {categories.map((category) => (
                <div
                  key={category.uuid}
                  className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white p-2"
                >
                  <button
                    className={`${actionClass} flex flex-1 items-center gap-2 text-left text-sm`}
                    onClick={() => onRestoreCategory(category)}
                  >
                    <AddIcon style={{ fontSize: 16 }} />
                    {category.name}
                  </button>
                  <button
                    className={actionClass}
                    aria-label={`Delete saved category ${category.name}`}
                    onClick={() => onDeleteCategory(category)}
                  >
                    <DeleteOutlinedIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
              ))}
            </div>
          </section>
        )}
        {agents.length > 0 && (
          <section className="mt-6">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">
              AI agents
            </h3>
            <div className="space-y-2">
              {agents.map((agent) => (
                <div
                  key={agent.uuid}
                  className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white p-2"
                >
                  <button
                    className={`${actionClass} flex flex-1 items-center gap-2 text-left text-sm`}
                    onClick={() => onRestoreAgent(agent)}
                  >
                    <AddIcon style={{ fontSize: 16 }} />
                    {agent.name}
                  </button>
                  <button
                    className={actionClass}
                    aria-label={`Edit saved agent ${agent.name}`}
                    onClick={() => onEditAgent(agent)}
                  >
                    <SettingsOutlinedIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
              ))}
            </div>
          </section>
        )}
        {!categories.length && !agents.length && (
          <p className="mt-6 text-sm text-slate-500">
            All saved items are already on the layout.
          </p>
        )}
      </div>
    </Drawer>
  );
}
